<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content class="font-montserrat">
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <div class="flex-1"></div>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">OK</button>
</div>
